import { apiSlice } from './apiSlice';

export interface Wallet {
  id: string;
  userId: string;
  type: string;
  amount: string;
  nonWithdrawableAmount: string;
  lockedAmount: string;
  exposureAmount: string;
  creditAmount: string;
  withdrawableBalance?: string;
  depositBalance?: string;
  currencyId: number;
  createdAt: string;
  updatedAt: string;
}

interface UserProfile {
  id: string;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  isSelfRegistered?: boolean;
  isAffiliateUser?: boolean;
  role?: { name: string };
}

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
      }),
      providesTags: ['User'],
    }),

    getUserWallets: builder.query<Wallet[], void>({
      query: () => ({
        url: '/users/me/wallets',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetUserProfileQuery, useGetUserWalletsQuery } = userApi;
